import { render } from "./NavProfile.vue?vue&type=template&id=366c6a00&scoped=true"
import script from "./NavProfile.vue?vue&type=script&lang=js"
export * from "./NavProfile.vue?vue&type=script&lang=js"

import "./NavProfile.vue?vue&type=style&index=0&id=366c6a00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366c6a00"],['__file',"src/components/helpers/NavProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "366c6a00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('366c6a00', __exports__)) {
    api.reload('366c6a00', __exports__)
  }
  
  module.hot.accept("./NavProfile.vue?vue&type=template&id=366c6a00&scoped=true", () => {
    api.rerender('366c6a00', render)
  })

}


export default __exports__